import _ from "lodash";

export const CUSTOM_TAB_KEY = "custom-columns";

export const getSchoolTabs = ({ academicRecordsData, selectedGradeId }) => {
  const grades = _.get(
    academicRecordsData,
    "node.transcriptSummary.grades",
    []
  );

  const applicableGrades = selectedGradeId
    ? _.filter(grades, grade => _.get(grade, "id") === selectedGradeId)
    : grades;

  const uniqueSchools = _.reduce(
    applicableGrades,
    (acc, grade) => {
      const sourceId = _.get(grade, "school.sourceId");
      if (!sourceId || acc[sourceId]) return acc;

      acc[sourceId] = {
        id: sourceId,
        label: _.get(grade, "school.name", ""),
      };
      return acc;
    },
    {}
  );

  return _.values(uniqueSchools);
};

export const getSchoolColumns = ({ curriculumProgramsById, selectedTab }) => {
  if (!selectedTab || selectedTab === CUSTOM_TAB_KEY) return [];

  const program = _.get(curriculumProgramsById, selectedTab, null);
  const edges = _.get(program, "gradeScale.edges", []);

  return _.map(edges, edge => ({
    id: _.get(edge, "node.id"),
    name: _.get(edge, "node.displayName", ""),
    type: _.get(edge, "node.type", null),
  }));
};

export const getInitialCustomColumns = ({
  transcriptGradeScalesData,
  generateId,
}) => {
  const customItems = _.filter(transcriptGradeScalesData, item =>
    _.get(item, "isCustom")
  );
  const sortedItems = _.sortBy(customItems, "displaySequence");

  return _.map(sortedItems, (item, index) => ({
    id: _.get(item, "id") || generateId(),
    name: _.get(item, "name") || _.get(item, "source.displayName", ""),
    displaySequence: index + 1,
    associations: _.get(item, "associations", {}),
  }));
};

export const buildGradeScaleInput = ({
  customColumns,
  initialCustomColumns,
}) => {
  const initialById = _.keyBy(initialCustomColumns, "id");
  const currentById = _.keyBy(customColumns, "id");

  const added = _.reduce(
    customColumns,
    (acc, column, index) => {
      if (!_.has(initialById, column.id)) {
        acc.push({
          name: _.trim(column.name || ""),
          displaySequence: index + 1,
        });
      }
      return acc;
    },
    []
  );

  const updated = _.reduce(
    customColumns,
    (acc, column, index) => {
      if (!_.has(initialById, column.id)) return acc;

      const initialItem = _.get(initialById, column.id, {});
      const name = _.trim(column.name || "");
      const displaySequence = index + 1;

      if (
        name !== _.trim(_.get(initialItem, "name", "")) ||
        displaySequence !== _.get(initialItem, "displaySequence")
      ) {
        acc.push({
          id: column.id,
          name,
          displaySequence,
        });
      }

      return acc;
    },
    []
  );

  const removed = _.reduce(
    initialCustomColumns,
    (acc, column) => {
      if (!_.has(currentById, column.id)) {
        acc.push({ id: column.id });
      }
      return acc;
    },
    []
  );

  return { added, updated, removed };
};

export const canDeleteCustomColumn = column =>
  _.get(column, "associations.totalCount", 0) === 0;
